import { Cancellation, PaymentStatus } from 'api/common/constants'
import { PositionResponse } from 'api/common/responses'
import { positionSelectAPI, positionsAPI } from 'api/position'
import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import loginData from 'utilities/loginData'
import InputSelectField from 'components/InputSelectField'
import { KeyValue } from 'utilities/resources/options'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [selectablePositions, setSelectablePositions] = React.useState<KeyValue[]>([])
  const [selectedPositionCount, setSelectedPositionCount] = React.useState<string>('1')
  const [buttonEnabled, setButtonEnabled] = React.useState(false)
  const [committed, setCommitted] = React.useState(false)

  /**
   * 「登録する」ボタン
   */
  const handleRegister = () => {
    setCommitted(true)
    const positionCount = Number(selectedPositionCount)
    positionSelectAPI({ positionCount }, (result: boolean) => {
      if (result) {
        loginData.setPositionContractSelectedData({ additionPositionCount: positionCount })
        navigate(loginData.getPositionSelectNextScene())
      } else {
        setCommitted(false)
      }
    })
  }

  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    } else {
      positionsAPI((response: PositionResponse) => {
        const registeredCount = response.positions.reduce(
          (count, position) =>
            count + (position.cancellationType !== Cancellation.Contract || position.paymentStatus === PaymentStatus.Paid || position.isChangedAssignment ? 1 : 0),
          0,
        )
        const registerableCount = Math.max(response.maxPositionCount, response.positions.length) - registeredCount
        const selectablePositions: KeyValue[] = []
        for (let i = 0; i < registerableCount; i++) {
          selectablePositions.push({
            key: `${i + 1}`,
            value: `${i + 1}`,
          })
        }
        setSelectablePositions(selectablePositions)
        setButtonEnabled(registerableCount > 0)
      })
    }
  }, [navigate])

  return (
    <>
      <Header title="ポジション数選択" />
      <main>
        <section className="mx-4 my-5">
          <div>
            <p>申込みを希望するポジション数を選択ください。</p>
            <p>2ポジション目以降は後ほど登録することも可能です。</p>
          </div>
          <Form className="mt-5">
            <InputSelectField name="position" label="ポジション数" items={selectablePositions} bold setValue={setSelectedPositionCount} />
            <div className="mt-5">
              <Button variant="primary" className="w-100 py-4" onClick={handleRegister} disabled={!(buttonEnabled && !committed)}>
                <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!committed} />
                登録する
              </Button>
            </div>
          </Form>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
